import { render, staticRenderFns } from "./PorletMenuHeader.vue?vue&type=template&id=622e6a43"
import script from "./PorletMenuHeader.vue?vue&type=script&lang=js"
export * from "./PorletMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./PorletMenuHeader.vue?vue&type=style&index=0&id=622e6a43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports